// extracted by mini-css-extract-plugin
module.exports = {"filterBarContainer":"FilterBar_filterBarContainer__2RJ5K","searchInput":"FilterBar_searchInput__79yJD"};